import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import BackToMainPageLink from '@src/components/BackToMainPageLink'
import React from 'react'
import RepairShopItem from '@src/components/RepairShopItem'
import { RepairShopSearchResultDto } from '@src/model/repairShopDom'

interface SelectedRepairShopInfoProps {
  repairShop?: RepairShopSearchResultDto | null
  uuid?: string
  headerComponent?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const SelectionHeader = ({ uuid }: SelectedRepairShopInfoProps) => {
  const { t } = useTranslation('repairshop')

  return (
    <Box>
      <Box sx={{ p: 2 }}>
        {uuid && (
          <Box mb={2}>
            <BackToMainPageLink uuid={uuid} />
          </Box>
        )}
        <Typography variant="h1" gutterBottom>
          {t('pre-commit-page.title')}
        </Typography>
      </Box>
    </Box>
  )
}

const SelectedRepairShopInfo = ({
  uuid,
  repairShop,
  headerComponent = 'h2',
}: SelectedRepairShopInfoProps) => {
  return (
    <Box sx={{ maxWidth: 'lg', marginX: 'auto' }}>
      <Stack>
        <SelectionHeader uuid={uuid} />
        {repairShop && (
          <RepairShopItem
            headerComponent={headerComponent}
            repairShop={repairShop}
            id={`selected-repair-shop-${repairShop.id}`}
          />
        )}
      </Stack>
    </Box>
  )
}

export default SelectedRepairShopInfo
